import { DatePickerType } from "@/graphql";
import { DateTime } from "luxon";

type DateBoundary = "start" | "end";

function toDateTime(value: string | DateTime | undefined): DateTime | undefined {
  if (value == null) {
    return undefined;
  }
  if (DateTime.isDateTime(value)) {
    return value.isValid ? value : undefined;
  }
  const date = DateTime.fromISO(value);
  return date.isValid ? date : undefined;
}

export function normalizeDateTimeToGranularity(
  value: string | DateTime | undefined,
  granularity: DatePickerType | undefined | null = DatePickerType.MINUTE,
  boundary: DateBoundary = "start",
): DateTime | undefined {
  const date = toDateTime(value);
  if (date == null) {
    return undefined;
  }

  const method = boundary === "end" ? "endOf" : "startOf";
  switch (granularity) {
    case DatePickerType.SECOND:
      return date[method]("second");
    case DatePickerType.MINUTE:
      return date[method]("minute");
    case DatePickerType.HOUR:
      return date[method]("hour");
    case DatePickerType.DAY:
      return date[method]("day");
    case DatePickerType.WEEK:
      return date[method]("week");
    case DatePickerType.MONTH:
      return date[method]("month");
    case DatePickerType.YEAR:
      return date[method]("year");
    default:
      return date[method]("minute");
  }
}

export function normalizeIsoDateToGranularity(
  value: string | DateTime | undefined,
  granularity: DatePickerType | undefined | null = DatePickerType.MINUTE,
  boundary: DateBoundary = "start",
): string | undefined {
  return normalizeDateTimeToGranularity(value, granularity, boundary)?.toISO() ?? undefined;
}
